import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51907888972078:1';
export function FinalCTASection() {
  const handleCTAClick = () => {
    console.log('InitiateCheckout tracked');
  };
  return <section className="bg-gradient-to-br from-[#3D2B1F] to-[#6B4C3B] text-[#FAF7F2] py-16 px-5 text-center" data-id="element-49">
      <div className="max-w-[900px] mx-auto" data-id="element-50">
        <h2 className="text-4xl md:text-5xl text-[#FAF7F2] mb-4" data-id="element-51">
          Tu Bebé No Puede Esperar.
        </h2>

        <p className="text-lg text-[rgba(250,247,242,0.8)] font-sans max-w-[600px] mx-auto mb-9 leading-relaxed" data-id="element-52">
          Cada día que pasa sin el sistema correcto es una ventana neurológica
          que se cierra. El primer año no se repite. La decisión es ahora.
        </p>

        <a href={CHECKOUT_URL} onClick={handleCTAClick} className="inline-block bg-gradient-to-r from-[#C9A96E] to-[#B76E79] text-white text-lg font-bold py-5 px-12 rounded-full tracking-wide shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse mb-6" data-id="element-53">
          ⚡ ACTIVAR MI ACCESO COMPLETO POR $14.97 →
        </a>

        <div className="flex justify-center gap-5 flex-wrap text-xs text-[rgba(250,247,242,0.6)] font-sans" data-id="element-54">
          <span className="flex items-center gap-1.5" data-id="element-55">🔒 Pago Seguro SSL</span>
          <span className="flex items-center gap-1.5" data-id="element-56">
            📥 Acceso Instantáneo
          </span>
          <span className="flex items-center gap-1.5" data-id="element-57">↩️ Garantía 30 Días</span>
        </div>
      </div>
    </section>;
}